export const appName = 'Knygos';

export const notificationsConfig = {
  defaultConf: {
    autoDismiss: 7,
    position: 'bc',
  },
};

export const versionConfig = {
  version: '6.09.22.07',
};

export const displayConfig = {
  maxCards: {
    books: 9,
    authors: 9,
    series: 9,
  },
  dateFormat: 'YYYY-MM-DD',
  dateTimeFormat: 'YYYY-MM-DD HH:mm',
  timeFormat: 'HH:mm',
  defaultLocale: 'lt',
  headerHeight: 180,
};

export const restrictions = {
  minPasswordLength: 6,
};

export enum Languages {
  lt = 'lt',
  en = 'en',
}

export const translationsConfig: {
  defaultNS: string[];
  app: string;
  lang: string;
} = {
  defaultNS: ['app'],
  app: 'app',
  lang: 'lang',
};

export const placeNames = {
  A: 'Augustinos',
  S: 'Santariškės',
  D: 'Druskininkai',
  M: 'Miglos',
};

export const placeNameAcroLen = 3;

export const separators = {
  csvField: ';',
  csvString: '"',
};

export type PaginationSettings = {
  firstLoad: number;
  loadMore: number;
};

export const pageSize = {
  books: { firstLoad: 10, loadMore: 10 } as PaginationSettings,
};

export const authorsListLen = 5;

export const debounceDelay = 750; // In ms

const constants = {
  versionConfig,
  displayConfig,
  notificationsConfig,
  translationsConfig,
};

export default constants;
